import React, { useState, useEffect }  from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MainRoutes from "./MainRoutes";
import Footer from "./Footer";
import { mainNavbarItems } from "../constants/mainNavbarItems";
import { Link } from "react-router-dom";
import MenuItem from '@mui/material/MenuItem';
// import authentication from "react-azure-b2c";
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { navbarStyles } from "./styles";
import Tooltip from '@mui/material/Tooltip';
import { useLocation} from "react-router-dom";
import { useOktaAuth } from '@okta/okta-react';
import { useSelector } from 'react-redux'



const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const sideBarMapping = {
  "/dashboard":0,
  "/users":1,
  "/devices":2,
  "/firmware":3,
  "/config-files":4,
  "/event-logs":5,
  "/tooltips":6,
  "/change-logs":7,
  "/remote-connect":8,
}

export default function SideBar() {
  const list  = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);

  const { authState, oktaAuth } = useOktaAuth();
  const [isPermanent, setPermanent] = useState(true);
  const location = useLocation();  
  const [value, setValue] = React.useState(sideBarMapping[location.pathname]);
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [isMobile,setIsMobile] = React.useState(false);
  const [isMobilePermanent,setIsMobilePermanent] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  const  handleWindowWidthChange = () => {
    let windowWidth = window.innerWidth;
    let breakpointWidth = theme.breakpoints.values.md;
    let isSmallScreen = windowWidth < breakpointWidth;
    if(isSmallScreen){
      setIsMobile(true)
    } else {
      setIsMobile(false)
    } 

    if (isSmallScreen && isPermanent) {
      setOpen(false);
      setPermanent(false);
      
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
      setOpen(true); 
    }

    if(isSmallScreen && isMobilePermanent){
      setIsMobilePermanent(true);
      setMobileOpen(true);
    } else if (!isSmallScreen && !isMobilePermanent){
      setIsMobilePermanent(false);
      setMobileOpen(false);
    }
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleMobileDrawerOpen = () => {
    setMobileOpen(true);
    setIsMobilePermanent(true);
  };

  const handleMobileDrawerClose = () => {
    setMobileOpen(false);
    setIsMobilePermanent(false);
  };

  const logOut = (event) => {
    oktaAuth.signOut();
    localStorage.clear();
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const menuId = 'primary-search-account-menu';
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const renderMenu = (
    <Menu
    sx={{ mt: '30px' }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem component={Link} to="/web/dashboard" onClick={handleMenuClose}>Dashboard</MenuItem>
      <MenuItem onClick={logOut}>Logout</MenuItem>
    </Menu>
  );

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const [menuActive,setMenuActive] = React.useState('');
  useEffect(() => {
    if(location.pathname && typeof value === 'undefined'){
      setMenuActive(location.pathname);
    } 
    if(location.pathname && typeof value !== 'undefined'){
      setValue('');
      setMenuActive(location.pathname);
    }
  },[location.pathname,value]);


  return (
    // <Box sx={{ display: 'flex' }}>
    // Added for the responsive view if any design not works change it to flex
    <Box sx={{ display: '-webkit-box' }}>
      <CssBaseline />
      { location.pathname !== "/web/remote-connect" && authState?.isAuthenticated &&
      <AppBar position="fixed">
        <Toolbar>
          {!isMobile ?
          <IconButton
            color="inherit"
            onClick={!open ?  handleDrawerOpen : handleDrawerClose}
            edge="start"
            sx={{
              marginRight: 5,
            }}
          >
            {!open 
            ?
             <MenuIcon />
             :
             <ChevronLeftIcon />
            }
          </IconButton>
          : 
          <IconButton
          color="inherit"
          onClick={!mobileOpen ?  handleMobileDrawerOpen : handleMobileDrawerClose}
          edge="start"
          sx={{
            marginRight: 5,
          }}
        >
          {!mobileOpen 
          ?
           <MenuIcon />
           :
           <ChevronLeftIcon />
          }
        </IconButton>   
        }

          <Typography variant="h6" noWrap component="div" sx={{flexGrow:1}}>
            Rehlink Sphere Portal
          </Typography>
          <div>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </div> 
        </Toolbar>
      </AppBar>
     }
    
     { location.pathname !== "/web/remote-connect" && authState?.isAuthenticated &&
      <Box sx={{ display: { md: "block", sm: "none", xs: "none", } }}>
        <Drawer sx={navbarStyles.drawer} variant={isPermanent ? "permanent" : "temporary"} open={open}>
          <Divider />
          <List sx={{paddingTop:10}}>
            {mainNavbarItems.map((item, index) => {
              let roleAccessDenied = false;
              let userAccessDenied = false;
              if(item.id === 2){
                let fileList = ['manageFirmware','manageConfigFiles','manageDefaultFiles','manageHistoryLogs'];
                list?.rolePermissions?.map(rp => fileList.includes(rp.key_name)  ? roleAccessDenied = true : roleAccessDenied);                
                list?.userPermissions?.map(up => fileList.includes(up.key_name) ? userAccessDenied = true : userAccessDenied);
              } else {
                list?.rolePermissions?.map(rp => rp.key_name === item.keyName ? roleAccessDenied = true : roleAccessDenied);
                list?.userPermissions?.map(up => up.key_name === item.keyName ? userAccessDenied = true : userAccessDenied);
              }
              return(
                  ((roleAccessDenied || userAccessDenied) &&
                  <ListItem key={item.id} disablePadding sx={{ display: 'block' }}>
                    <ListItemButton
                      component={Link}
                      to={item.route}
                      selected={value === index || menuActive === item.route }
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                      }}
                      onClick={(event) => {              
                        setValue(index);
                        setMenuActive('');
                      }}
                    > 
                      <Tooltip title={open === false ? item.label : ''}>
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 1.5 : 'auto',
                            justifyContent: 'center',
                            color:'rgba(255, 255, 255, 0.7)'
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                      </Tooltip>
                      <ListItemText primary={<Typography variant="span" >{item.label}</Typography>} sx={{ opacity: open ? 1 : 0 }} />
                    </ListItemButton>
                  </ListItem>
                )
              )
            })}
          </List>
          <Divider />
        </Drawer>
      </Box>
    }
    { location.pathname !== "/web/remote-connect" && authState?.isAuthenticated &&
      <Box sx={{ display: { md: "none", sm: "block", xs: "block"} }}>
        <Drawer 
          variant={isMobilePermanent ? 'permanent' : 'temporary' }
          open={mobileOpen}
          sx={navbarStyles.responsiveDrawer}
        >
          <List sx={{paddingTop:8}}>
          {mainNavbarItems.map((item, index) => {
            let roleAccessDenied = false;
            let userAccessDenied = false;
            if(item.id === 2){
              let fileList = ['manageFirmware','manageConfigFiles','manageDefaultFiles','manageHistoryLogs'];
              list?.rolePermissions?.map(rp => fileList.includes(rp.key_name)  ? roleAccessDenied = true : roleAccessDenied);                
              list?.userPermissions?.map(up => fileList.includes(up.key_name) ? userAccessDenied = true : userAccessDenied);
            } else {
              list?.rolePermissions?.map(rp => rp.key_name === item.keyName ? roleAccessDenied = true : roleAccessDenied);
              list?.userPermissions?.map(up => up.key_name === item.keyName ? userAccessDenied = true : userAccessDenied);
            }
            return(
              ((roleAccessDenied || userAccessDenied) &&
                  <ListItem key={item.id} disablePadding sx={{ display: 'block' }}>
                    <ListItemButton
                      component={Link}
                      to={item.route}
                      selected={value === index || menuActive === item.route}
                      sx={{
                        minHeight: 48,
                        px: 2.5,
                      }}
                      onClick={(event) => {     
                        handleMobileDrawerClose();         
                        setValue(index);
                        setMenuActive('');
                      }}
                    > 
                      <Tooltip title={ item.label}>
                        <ListItemIcon
                          sx={{
                            justifyContent: 'center',
                            color:'rgba(255, 255, 255, 0.7)'
                          }}
                        >
                          {item.icon}
                      </ListItemIcon>
                      </Tooltip>
                      <ListItemText primary={<Typography variant="span" >{item.label}</Typography>}  />
                    </ListItemButton>
                  </ListItem>
              )
            )   
          })}
        </List>
          </Drawer>            
      </Box>
    }
      <Box component="main" sx={{ paddingTop: location.pathname ===  "/web/remote-connect" ? '5px !important' : '24px',  paddingBottom:'70px !important',position:'relative',minHeight:'100vh',flexGrow: 1, p:3, }}>
        { location.pathname !== "/web/remote-connect" && authState?.isAuthenticated &&
          <DrawerHeader />  
        }    
        <MainRoutes />
        { location.pathname !== "/web/remote-connect" && authState?.isAuthenticated &&
          <Footer />
        }
        {renderMenu}
      </Box>
      
    </Box>
  );
}
